<template>
  <div class="search" @touchmove.prevent @mousewheel.prevent>
    <!-- 输入框 -->
    <div class="searchBox backbox">
      <div class="content">
        <div class="input-box flex-between">
          <input
            clearable
            @clear="clear()"
            v-model="value"
            placeholder="请输入选手编号或名称"
          />
        </div>
        <div class="searchBtn">
          <van-button @click="gotoVote()" type="primary">搜索</van-button>
        </div>
      </div>
    </div>
    <!-- 关闭按钮 -->
    <div class="close">
      <van-icon @click="close()" name="close" />
    </div>
  </div>
</template>

<script>
import searchMixin from "@/mixins/search.js";
export default {
  mixins: [searchMixin],
  data() {
    return {
      info: JSON.parse(sessionStorage.getItem("info")),
    };
  },
};
</script>

<style lang="less" scoped>
.searchBox::before {
  position: absolute;
  background: url("@/assets/elevenpoll/sslogo.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  content: "";
  width: 4.8rem;
  top: -.2rem;
  height: 1.12rem;
  left: 1.6rem;
}
.backbox {
  padding-bottom: 0.05rem !important;
  text-align: center;
  background: #140f62 !important;
  border: 3px solid #484bfb !important;
  border-radius: .18rem !important;
  box-shadow: 0.05rem 0 #00e4ff, -0.05rem 0 #d33fee !important;
  -webkit-box-shadow: 0.05rem 0 0 0 #00e4ff, -0.05rem 0 0 0 #d33fee !important;
}

.van-button--primary {
  border: 0px solid !important;
}
.search {
  width: 10rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-width: 10rem;
  margin: auto;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  .searchBox {
    width: 8.04rem;
    height: 5.3876667rem;
    box-sizing: border-box;
    position: relative;
    .content {
      width: 96%;
      height: 4rem;
      position: absolute;
      bottom: .3666667rem;
      left: 0;
      right: 0;
      margin: auto;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      .input {
        margin: 1.0666667rem 0 .5333333rem;
        .van-search {
          background: #f0fffa;
        }
      }
      .searchBtn {
        height: 1rem;
        width: 3.4rem;
        padding: 0 .1rem;
        box-sizing: border-box;
        .van-button {
          width: 100%;
          height: 100%;
          background: linear-gradient(90deg, #d200f8, #3ca5ff);
          background-size: 100% 100%;
          background-repeat: no-repeat;
        }
      }
      .input-box {
        width: 6.95rem;
        height: 1.129rem;
        border-radius: .14rem;
        box-shadow: -0.01rem -0.01rem rgba(88, 0, 2, 0.5),
          0.01rem 0.01rem rgba(255, 250, 231, 0.7);
        padding-left: .2rem;
        background-color: #251f83;
        margin-bottom: .7rem;
        box-sizing: content-box;
        input {
          width: 70%;
          color: #fff;
          position: relative;
          border: 0rem;
          top: .28rem;
          background-color: #251f83;
          font-size: .3733333rem !important;
          left: 0.4rem;
        }
        input::-webkit-input-placeholder {
          color: #adadf6;
        }
        .search-img {
          -webkit-box-flex: 0;
          -webkit-flex: none;
          -ms-flex: none;
          flex: none;
          width: 0.4rem;
          height: 0.4rem;
          color: #ffe6e6;
          margin-top: 0.04rem;
        }
        .search-img::before {
          content: "\e6ae";
        }
      }
    }
  }
  div.close {
    margin-top: .5333333rem;
    .van-icon-close {
      font-size: .96rem;
      color: #fff;
    }
  }
}
</style>